













































































































































































import { Component, Prop } from 'vue-property-decorator';
import {
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { Snotify } from '@/snotify/Snotify';
import BuscadorOperacionCrud from '@/reusable/Grid/BuscadorOperacionCrud.vue';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import { fetchReportesSerie } from '../fetchReporteSerie';
import { actionsEvent } from '@/setup';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import Confirmation from '@/components/Confirmation.vue';
@Component({
  components: {
    StepTitle,
    BuscadorOperacionCrud,
    MantenedorGridSinCodigo,
    FormFieldsContainer,
    'app-confirmacion': Confirmation,
  },
})
export default class TelcoFormStock extends ComponenteBase {
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: null }) telcoid: any;

  /* ComponenteBase */
  ordesList: any[] = [];
  serverSide: any;
  showReporteGeneradoEditar: boolean = false;

  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.MantenedorTelcoEditarStock;

  /* aggrid */

  gridApi: GridApi = null;
  tipolist: any[] = [];
  showReporteGeneradoCrear: boolean = false;
  dialogConfirmacion: boolean = false;
  /* template */
  async getplan() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        '': '',
      },
      'mantenedor_telco/tipo_sim'
    )
      .then((data: any) => {
        if (data.data.MENSAJE_RESPUESTA == 'sin registros') {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        } else if (data.data.CODIGO_RESPUESTA == '1') {
          self.tipolist = data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'tiposimid',
        field: 'tiposimid',
        lockVisible: true,
        hide: true,
      },
      {
        headerName: 'TelcoId',
        field: 'telcoid',
        lockVisible: true,
        hide: true,
      },
      {
        headerName: 'Tipo SIM',
        field: 'tiposimname',
        lockVisible: true,
      },
      {
        headerName: 'Stock',
        field: 'telcostockcritico',
        lockVisible: true,
      },
    ],
    pagination: true,
    singleClickEdit: true,
    paginationPageSize: 5,
    onGridReady: this.handleGridReady,
    suppressCopyRowsToClipboard: true,
  };

  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  crear_stock() {
    this.showReporteGeneradoCrear = true;
  }
  closeReportecrear() {
    this.formFields.stock.value = '';
    this.showReporteGeneradoCrear = false;
  }

  formFields: FormFieldDefMap = {
    simid: {
      label: 'id SIM',
      id: '',
      value: '',
    },
    sim: {
      label: 'Tipo SIM',
      id: '',
      value: '',
    },
    stock: {
      label: 'Stock',
      id: '',
      value: '',
    },
  };

  async getReportes(telcoid: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { telcoid: self.telcoid },
      'mantenedor_telco/stock'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          console.log(data.data.data.LISTA);
          return data.data.data.LISTA;
        } else {
          return;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getReportes(this.telcoid);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    console.log(this.tipolist);
  }
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionEditarStock: PermisoAccion = {
    accionCodigo: 98,
    visible: false,
  };

  accionEliminarStock: PermisoAccion = {
    accionCodigo: 99,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionEditarStock,
    this.accionEliminarStock,
  ];
  constructor() {
    super();
    actionsEvent.onEditarStock(this.handleVerEditarStock);
    actionsEvent.onEliminarStock(this.handleElminarStock);
  }
  handleVerEditarStock(params: ICellRendererParams) {
    (this.formFields.simid.value = params.data.tiposimid),
      (this.formFields.sim.value = params.data.tiposimname),
      (this.formFields.stock.value = params.data.telcostockcritico),
      (this.telcoid = params.data.telcoid);
    this.showReporteGeneradoEditar = true;
  }
  async editarStock() {
    let self = this;
    this.loadingService.showLoading();
    if (this.formFields.stock.value == '') {
      self.$snotify.error('Debe incluir un Stock', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    return fetchReportesSerie(
      {
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
        usuariorut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
        clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
        bmoduloid: this.funcionalidad,
        telcostockcritico: this.formFields.stock.value,
        tiposimid: this.formFields.simid.value,
        telcoid: this.telcoid,
      },
      'mantenedor_telco/editar_stock'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordesList = await this.getReportes(this.telcoid);
          this.gridApi.setRowData(this.ordesList);
          this.formFields.stock.value = '';
          this.showReporteGeneradoEditar = false;
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  closeReporteEditar() {
    this.formFields.stock.value = '';
    this.showReporteGeneradoEditar = false;
  }

  nombreStockElminar: any = '';
  tipoSimIdEliminar: any = '';
  handleElminarStock(params: ICellRendererParams) {
    (this.tipoSimIdEliminar = params.data.tiposimid),
      (this.telcoid = params.data.telcoid);
    this.nombreStockElminar = params.data.tiposimname;
    this.dialogConfirmacion = true;
  }
  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;

    if (val) {
      let self = this;
      this.loadingService.showLoading();

      return fetchReportesSerie(
        {
          usuarioid: JSON.parse(localStorage.getItem('user')).id,
          usuariorut: JSON.parse(localStorage.getItem('user'))
            .rutClienteDefecto,
          bmoduloid: this.funcionalidad,
          clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
          telcoid: this.telcoid,
          tiposimid: this.tipoSimIdEliminar,
        },
        'mantenedor_telco/eliminar_stock'
      )
        .then(async (data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.ordesList = await this.getReportes(this.telcoid);
            this.gridApi.setRowData(this.ordesList);
            self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
    }
  }
  async crearStock() {
    let self = this;
    this.loadingService.showLoading();
    if (this.formFields.stock.value == '') {
      self.$snotify.error('Debe incluir un Stock', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    return fetchReportesSerie(
      {
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
        usuariorut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
        clienteid: JSON.parse(localStorage.getItem('clienteDefecto')),
        bmoduloid: this.funcionalidad,
        telcostockcritico: this.formFields.stock.value,
        tiposimid: this.formFields.sim.value,
        telcoid: this.telcoid,
      },
      'mantenedor_telco/crear_stock'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordesList = await this.getReportes(this.telcoid);
          this.gridApi.setRowData(this.ordesList);
          this.formFields.stock.value = '';
          this.formFields.sim.value = '';
          this.showReporteGeneradoCrear = false;
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  async mounted() {
    this.getplan();
  }
}
